export const scrollToAnchor = anchor => {
    document.getElementById(anchor).scrollIntoView({ behavior: 'smooth' });
};

document.addEventListener('DOMContentLoaded', () => {
    // Scroll on page load on page navigation
    const anchor = window.location.hash.substring(1);
    if (anchor.length > 0) {
        setTimeout(() => {
            window.scrollTo(0, 0);
            scrollToAnchor(anchor);
        }, 1);
    }

    // Attach the function to all in-page anchor links
    // event listener for all clicks
    document.addEventListener('click', e => {
        const clickedElement = e.target;
        // Check if the clicked element is a link
        if (clickedElement.tagName === 'A') {
            const href = clickedElement.getAttribute('href');
            // Check if the link points to an in-page anchor
            if (href && href.startsWith('#')) {
                // Prevent default link behavior (which snaps the page to the anchor instantly)
                e.preventDefault();
                // Scroll to the anchor smoothly
                scrollToAnchor(href.substring(1));
            }
        }
    });
});
